import { Component, OnInit } from '@angular/core';
import { commonImports } from '../../common';
import { TokenService } from '../../services/auth-token-service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-auth-response',
  imports: [...commonImports],
  templateUrl: './auth-response.component.html',
  styleUrl: './auth-response.component.scss',
})
export class AuthResponseComponent implements OnInit {
  hasError = false;
  errorMessage?: string;

  constructor(
    private tokenService: TokenService,
    private router: Router,
  ) {}
  async ngOnInit() {
    try {
      await this.tokenService.processLoginResponse();
      this.router.navigate(['/']);
    } catch (e) {
      this.hasError = true;
      if (e instanceof Error) {
        this.errorMessage = e?.message;
      }
    }
  }

  logoutClicked(): void {
    // logout();
    window.location.href = '/';
  }
}
